function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3262",
  "data-name": "Group 3262",
  transform: "translate(-406.595 -381.736)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_257",
  "data-name": "Group 257",
  transform: "translate(417.357 398.223)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_490",
  "data-name": "Line 490",
  x2: 5.815,
  y2: 5.815,
  transform: "translate(5.814)",
  fill: "none",
  stroke: "#c6ccd3",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_656",
  "data-name": "Path 656",
  d: "M512.976,524.906l-5.814,5.815",
  transform: "translate(-507.162 -524.906)",
  fill: "none",
  stroke: "#c6ccd3",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.7
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_491",
  "data-name": "Line 491",
  y2: 11.678,
  transform: "translate(422.941 398.909)",
  fill: "none",
  stroke: "#c6ccd3",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.7
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_258",
  "data-name": "Group 258",
  transform: "translate(407.447 382.586)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_657",
  "data-name": "Path 657",
  d: "M428.986,399.262V390.7l-8.28-8.112H409.113c-1.159,0-1.656.487-1.656,1.622v22.712a1.467,1.467,0,0,0,1.3,1.622,1.531,1.531,0,0,0,.352,0h6.624",
  transform: "translate(-407.447 -382.586)",
  fill: "none",
  stroke: "#c6ccd3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_658",
  "data-name": "Path 658",
  d: "M531.006,392.277h-7.753a1.744,1.744,0,0,1-1.938-1.526,1.7,1.7,0,0,1,0-.412v-7.753",
  transform: "translate(-509.467 -382.586)",
  fill: "none",
  stroke: "#c6ccd3",
  strokeLinejoin: "round",
  strokeWidth: 1.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_659",
  "data-name": "Path 659",
  d: "M436,439.514",
  transform: "translate(-432.113 -433.025)",
  fill: "none",
  stroke: "#c6ccd3",
  strokeLinejoin: "round",
  strokeWidth: 1.7
})));

var SvgUploadFileIcon = function SvgUploadFileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.593,
    height: 29.701,
    viewBox: "0 0 23.593 29.701",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadFileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload_file_icon.2bbeeb67.svg";
export { ForwardRef as ReactComponent };